<template>
  <div class="col-12 p-0">
    <input id="userRole" type="hidden" />
    <!----------------Top Header---------->
    <b-navbar variant="faded" type="light">
      <b-navbar-brand>
        <a
          href="https://www.evalueserve.com/"
          target="_blank"
          class="d-inline-block"
        >
          <img
            alt="logo"
            class="d-inline-block align-top"
            v-bind:src="pageLogo"
          />
        </a>
        <div class="navbar-text float-right headerText">
          <router-link to="/dashboard" v-slot="{ href, navigate }">
            <a
              :href="href"
              @click="navigate"
              class="d-inline-block text-white text-decoration-none"
            >
              <h6>
                INTERACTIVE RESEARCH
                <br /><span>{{ pageTitle }}</span>
              </h6>
            </a>
          </router-link>
        </div>
      </b-navbar-brand>
    </b-navbar>
    <updateDataModal></updateDataModal>
  </div>
</template>

<script>
//Import Images
import pageLogo from "@/assets/img/Evalueserve_logo_white.png";
import updateDataModal from "../Common/upload-download/update-data-modal.vue";

export default {
  name: "TopHeader",
  components: {
    updateDataModal,
  },
  data() {
    return {
      pageLogo: pageLogo,
    };
  },
  props: {
    pageTitle: { default: "Dashboard" },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/base.scss";

/***************Top Header************************/
.navbar-brand {
  img {
    height: 45px;
  }
  width: 100%;
}
.headerText {
  h6 {
    span {
      text-transform: capitalize;
      font-size: 18px;
    }
    font-size: 20px !important;
    line-height: 20px;
  }
  color: $color-white !important;
  padding-top: 0.25rem !important;
  padding-bottom: 0.125rem !important;
  text-align: right;
}
</style>
